import React, { FC, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actionUpdateReportAction } from '../../../../redux/action/userSingleReport/actionUserSingleReport';
import { formatReportData } from '../../../../utils/formatReportData';
import { AppDispatch } from '../../../../redux/reducer/store';

import EditPopup from '../../../custom/editPopup/editPopup';
import ArrowIcon from '../../../../assets/icons/chevron.svg';

import { IReportActionOptions } from '../../../../types/reportsInterfaces';
import { IUserOptions } from '../../../../types/interfaces';

const ActionTableSection: FC = () => {
	const dispatch = useDispatch<AppDispatch>();

	const { report } = useSelector(
		(state: any) => state.userSingleReport.userSingleReport
	);
	const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

	const [openOutletActionValueIndex, setOpenOutletActionValueIndex] =
		useState<number>(-1);
	const [openOutletActionHotlineIndex, setOpenOutletActionHotlineIndex] =
		useState<number>(-1);
	const [newActionHotline, setNewActionHotline] = useState<string>('');
	const [newActionValue, setNewActionValue] = useState<string>('');
	const [isVisibleData, setIsVisibleData] = useState<boolean>(true);

	const modalRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick);

		return () => {
			document.removeEventListener('mousedown', handleDocumentClick);
		};
	}, []);

	const handleClickCancelRenameBtn = () => {
		setOpenOutletActionHotlineIndex(-1);
		setOpenOutletActionValueIndex(-1);
	};

	const handleChangeReportData = (index: number, section: string) => {
		const sectionToStateMap: { [key: string]: { state: number; setState: (state: number) => void } } = {
			outletActionValue: {
				setState: setOpenOutletActionValueIndex,
				state: openOutletActionValueIndex,
			},
			outletActionHotline: {
				setState: setOpenOutletActionHotlineIndex,
				state: openOutletActionHotlineIndex,
			},
		};

		const setOpenIndexFunction = sectionToStateMap[section];

		if (setOpenIndexFunction) {
			if (index === setOpenIndexFunction.state) {
				return;
			} else {
				setOpenIndexFunction.setState(index);
			}
		}
	};

	const handleAcceptRenameAction = (action: IReportActionOptions, typeOfValue: string) => {
		dispatch(
			actionUpdateReportAction({
				reportId: report && report.reportId.id,
				data: [
					{
						action: {
							id: action.action.id,
						},
						hotline:
							typeOfValue === 'hotline'
								? newActionHotline || action.hotline
								: action.hotline,
						value:
							typeOfValue === 'value'
								? newActionValue || action.value
								: action.value,
					},
				],
			})
		);

		handleClickCancelRenameBtn();
		setNewActionHotline('');
		setNewActionValue('');
	};

	const handleAcceptEditOnKeyPress = (
		event: React.KeyboardEvent<HTMLInputElement>,
		action: IReportActionOptions,
		type: string
	) => {
		if (event.key === 'Enter') {
			handleAcceptRenameAction(action, type);
		}
	};

	const handleDocumentClick = (event: MouseEvent) => {
		if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
			setOpenOutletActionHotlineIndex(-1);
			setOpenOutletActionValueIndex(-1);
		}
	};
	return (
		<div className={`sectionData ${isVisibleData ? 'sectionData_active  sectionData__overflow' : ''}`}>
			<span className='section__title'>Акции по ТТ</span>
			<button
				className='sectionData_button'
				onClick={() => setIsVisibleData(!isVisibleData)}
			>
				<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
			</button>
			<table className='customerOutlet__data_table'>
				<thead className='tunder__thead'>
					<tr>
						<th>Наименование</th>
						<th>Значение</th>
						<th>Горячая линия</th>
					</tr>
				</thead>
				<tbody>
					{report &&
						report?.actions?.map((action: IReportActionOptions, index: number) => {
							return (
								<tr key={index}>
									<td>{action.action.name}</td>
									<td
										onClick={() => {
											if (
												claims.includes('admin') ||
												claims.includes('reports:edit')
											) {
												handleChangeReportData(index, 'outletActionValue');
											}
										}}
										className='edit__data_text'
									>
										<span
											className={
												formatReportData(action?.changes)?.includes('value')
													? 'changed__table_value'
													: formatReportData(action?.equals)?.includes('Value')
														? 'previous__table_value'
														: ''
											}
										>
											{action.value}
										</span>
										{openOutletActionValueIndex === index && (
											<EditPopup
												handleClickAcceptRenameBtn={() =>
													handleAcceptRenameAction(action, 'value')
												}
												handleAcceptOnKeyPress={(event: React.KeyboardEvent<HTMLInputElement>) =>
													handleAcceptEditOnKeyPress(event, action, 'value')
												}
												handleClickCancelRenameBtn={handleClickCancelRenameBtn}
												handleChangeValue={(event: React.ChangeEvent<HTMLInputElement>) => {
													setNewActionValue(event?.target.value);
												}}
												defaultValue={action.value}
												className='edit__popup'
												modalRef={modalRef}
											/>
										)}
									</td>
									<td
										onClick={() => {
											if (
												claims.includes('admin') ||
												claims.includes('reports:edit')
											) {
												handleChangeReportData(index, 'outletActionHotline');
											}
										}}
										className='edit__data_text'
									>
										<span
											className={
												formatReportData(action?.changes)?.includes('hotline')
													? 'changed__table_value'
													: formatReportData(action?.equals)?.includes(
														'Hotline'
													)
														? 'previous__table_value'
														: ''
											}
										>
											{action.hotline || '—'}
										</span>
										{openOutletActionHotlineIndex === index && (
											<EditPopup
												handleClickAcceptRenameBtn={() =>
													handleAcceptRenameAction(action, 'hotline')
												}
												handleAcceptOnKeyPress={(event: React.KeyboardEvent<HTMLInputElement>) =>
													handleAcceptEditOnKeyPress(event, action, 'hotline')
												}
												handleClickCancelRenameBtn={handleClickCancelRenameBtn}
												handleChangeValue={(event: React.ChangeEvent<HTMLInputElement>) => {
													setNewActionHotline(event?.target.value);
												}}
												defaultValue={action.hotline}
												className='edit__popup'
												modalRef={modalRef}
											/>
										)}
									</td>
								</tr>
							);
						})}
				</tbody>
			</table>
		</div>
	);
};

export default ActionTableSection;
